import { cacheKey } from "./runsHelpers"
import { extractLogs } from "./logsHelpers"

export function parseIterationsFromLogs(logText) {
  if (!logText || typeof logText !== "string") return []

  const iterations = []

  const tryPush = (obj) => {
    if (!obj || typeof obj !== "object") return
    const iter =
      obj.iteration ??
      obj.iter ??
      obj.step ??
      (typeof obj.i === "number" ? obj.i : undefined)
    if (iter === undefined) return
    iterations.push({
      iteration: Number(iter),
      metrics: obj.metrics || obj.eval || undefined,
      summary: obj.summary || undefined,
      snapshot: obj.snapshot || undefined,
      ts: obj.ts || obj.timestamp || undefined,
    })
  }

  const lines = logText.split(/\r?\n/)
  for (const line of lines) {
    const trimmed = line.trim()
    if (!trimmed) continue
    if (trimmed.includes("{") && trimmed.includes("}") && /iter/i.test(trimmed)) {
      try {
        const obj = JSON.parse(trimmed)
        tryPush(obj)
      } catch {}
    }
  }

  const fenceRe = /```(?:json)?\s*([\s\S]*?)```/gi
  let m
  while ((m = fenceRe.exec(logText)) !== null) {
    const body = m[1].trim()
    try {
      const parsed = JSON.parse(body)
      if (Array.isArray(parsed)) {
        parsed.forEach(tryPush)
      } else {
        tryPush(parsed)
      }
    } catch {}
  }

  const objRe = /{[\s\S]*?}/g
  let objMatch
  while ((objMatch = objRe.exec(logText)) !== null) {
    const chunk = objMatch[0]
    if (!/iteration|"iter"|"step"/i.test(chunk)) continue
    try {
      const obj = JSON.parse(chunk)
      tryPush(obj)
    } catch {}
  }

  const byIter = new Map()
  for (const it of iterations) {
    byIter.set(it.iteration, { ...(byIter.get(it.iteration) || {}), ...it })
  }
  const out = Array.from(byIter.values())
  out.sort((a, b) => (a.iteration ?? 0) - (b.iteration ?? 0))
  return out
}

export function getIterations(run) {
  if (!run) return []
  if (Array.isArray(run.iterations) && run.iterations.length) return run.iterations
  const logs = extractLogs(run)
  return parseIterationsFromLogs(logs)
}

export function num(v, d = 2) {
  const n = Number(v)
  if (!isFinite(n)) return "—"
  const factor = Math.pow(10, d)
  return Math.round(n * factor) / factor
}

export function loadIterationToGraph(dataset, iter) {
  try {
    const snap = iter?.snapshot || {}
    localStorage.setItem(
      cacheKey(dataset),
      JSON.stringify({
        nodes: snap.nodes || [],
        edges: snap.edges || [],
        metrics: iter?.metrics || {},
        ts: Date.now(),
      })
    )
    sessionStorage.setItem(
      "pg_last_run_params",
      JSON.stringify({ fromIteration: iter.iteration })
    )
  } catch {}
  window.location.href = "/GraphInfo"
}
